export interface EntityListQueryOptions {
  page: number;
  size: number;
  sortBy: string;
  status?: string;
  createdBy?: string;
  lastModifiedBy?: string;
}

export const DEFAULT_LIST_SORT_BY = 'lastModifiedOn';

export const FEATURE_LIST_SORT_OPTIONS = [
  { label: 'Recently Modified', value: 'lastModifiedOn' },
  { label: 'Name (A → Z)', value: 'featureName' },
  { label: 'Created (Newest)', value: 'createdOn' },
] as const;

export const PLAN_LIST_SORT_OPTIONS = [
  { label: 'Recently Modified', value: 'lastModifiedOn' },
  { label: 'Name (A → Z)', value: 'planName' },
  { label: 'Created (Newest)', value: 'createdOn' },
] as const;

export function buildEntityListParams(options: EntityListQueryOptions): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: options.page,
    size: options.size,
    sortBy: options.sortBy,
  };

  if (options.status) {
    params['status'] = options.status;
  }

  const createdBy = options.createdBy?.trim();
  if (createdBy) {
    params['createdBy'] = createdBy;
  }

  const lastModifiedBy = options.lastModifiedBy?.trim();
  if (lastModifiedBy) {
    params['lastModifiedBy'] = lastModifiedBy;
  }

  return params;
}

export interface LeadListQueryOptions {
  page: number;
  size: number;
  sortBy: string;
  organizationName?: string;
}

export const DEFAULT_LEAD_SORT_BY = 'organizationName';

export const LEAD_LIST_SORT_OPTIONS = [
  { label: 'Organization Name', value: 'organizationName' },
  { label: 'Contact Name', value: 'name' },
  { label: 'Email', value: 'email' },
  { label: 'Submitted (Newest)', value: 'createdAt' },
] as const;

export function buildLeadListParams(options: LeadListQueryOptions): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: options.page,
    size: options.size,
    sortBy: options.sortBy,
  };

  const organizationName = options.organizationName?.trim();
  if (organizationName) {
    params['organizationName'] = organizationName;
  }

  return params;
}

export interface IncompleteEnterpriseListQueryOptions {
  page: number;
  size: number;
  sort: 'asc' | 'desc';
  search?: string;
}

export const DEFAULT_INCOMPLETE_ENTERPRISE_SORT = 'asc' as const;

export const INCOMPLETE_ENTERPRISE_SORT_OPTIONS = [
  { label: 'Name (A → Z)', value: 'asc' },
  { label: 'Name (Z → A)', value: 'desc' },
] as const;

export function buildIncompleteEnterpriseListParams(
  options: IncompleteEnterpriseListQueryOptions,
): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: options.page,
    size: options.size,
    sort: options.sort,
  };

  const search = options.search?.trim();
  if (search) {
    params['search'] = search;
  }

  return params;
}

export interface EnterpriseListQueryOptions {
  page: number;
  size: number;
}

export const DEFAULT_ENTERPRISE_LIST_PAGE_SIZE = 200;

export function buildEnterpriseListParams(
  options: EnterpriseListQueryOptions,
): Record<string, string | number> {
  return {
    page: options.page,
    size: options.size,
  };
}
